import * as z from "zod";

/** The tests page's tabs: routes beside each test's, so no test may take one as its id. */
export const SHOPPER_AGENT_TESTS_TABS = ["running", "stopped", "all"] as const;

export type ShopperAgentTestsTab = (typeof SHOPPER_AGENT_TESTS_TABS)[number];

const tabs: ReadonlySet<string> = new Set(SHOPPER_AGENT_TESTS_TABS);

export const isShopperAgentTestsTab = (
  value: string,
): value is ShopperAgentTestsTab => tabs.has(value);

export const startShopperAgentTest = {
  name: "startShopperAgentTest" as const,
  input: z.object({
    kind: z.string(),
    /** A new test id: a new split never reuses one, so runs never mix. */
    testId: z.string(),
    weights: z.record(z.string(), z.number().int().nonnegative()),
  }),
  output: z.object({
    /** The kind's live test, which starting this one stopped. */
    stoppedTestId: z.string().nullable(),
  }),
};

export const pullShopperAgentTestArm = {
  name: "pullShopperAgentTestArm" as const,
  input: z.object({
    testId: z.string(),
    arm: z.string(),
    /** The arm its open spans run from their next message; null lifts the pull. */
    runsArm: z.string().nullable(),
    reason: z.string(),
  }),
  output: z.object({}),
};

export const stopShopperAgentTest = {
  name: "stopShopperAgentTest" as const,
  input: z.object({ testId: z.string() }),
  output: z.object({}),
};
